import React, { useContext } from 'react';
import { useTranslation } from "react-i18next";
import { Modal, Table, Button } from 'react-bootstrap';
import { FaTimes, FaSearch, FaTrash, FaCheck } from 'react-icons/fa';
import { getApiChara } from '../../util/getApi';
import { getAuthToken } from '../../util/auth';
import { useNavigate } from "react-router-dom";
import AuthContext from '../../store/auth-context';
import { useState } from 'react';
import ConfirmModal from './ConfirmModal';
import { toast } from 'react-toastify';

const DataModal = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const { prescriptions } = props;
  const prescriptionsArray = Object.values(prescriptions);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [selectedPresPreNumber, setSelectedPresPreNumber] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const selectPrescriptionHandler = (selectedPrescription) => {
    props.onAddToMedicineTable(selectedPrescription);
    props.OnCloseModalBlock();
  };

  const deletePrescriptionHandler = (selectedPrescription) => {
    setSelectedPresPreNumber(selectedPrescription[0]?.preNumber);
    setShowConfirmModal(true);
  };

  const confirmDeleteHandler = async () => {
    if (!selectedPresPreNumber) return;
    setIsDeleting(true);

    const token = getAuthToken();
    if (token === null || token === 'EXPIRED') {
      navigate('/');
      return;
    }

    const apiChar = getApiChara();
    const tenantOrClientId = Number(authCtx.tenantOrClientId);
    const apiUrl = `${apiChar}/savedPrescription/deleteSavedPrescriptionRecordsByPreNumber?preNumber=${selectedPresPreNumber}&tenantOrClientId=${tenantOrClientId}`;

    try {
      const response = await fetch(apiUrl, {
        method: 'DELETE',
        headers: {
          'Authorization': 'Bearer ' + token
        }
      });

      if (!response.ok) {
        throw new Error("Could not delete");
      } else {
        toast.success("Prescription deleted successfully");
        props.OnCloseModalBlock();
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to delete prescription. Please try again.");
    } finally {
      setIsDeleting(false);
      setShowConfirmModal(false);
    }
  };

  return (
    <Modal show={true} onHide={props.OnCloseModalBlock} size="lg" centered scrollable>
      <Modal.Header closeButton style={{ backgroundColor: "var(--primary-color)", color: "white" }}>
        <Modal.Title><FaSearch className="me-2" /> Prescriptions</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#f8f9fa" }}>
        {prescriptionsArray.length === 0 ? (
          <p className="text-center py-4">No prescriptions found.</p>
        ) : (
          prescriptionsArray.map((prescription, index) => (
            <div key={index} className="card mb-4 shadow-sm">
              <div className="card-body p-0">
                <Table responsive striped hover className="mb-0 overflow-hidden" style={{ borderRadius: "8px" }}>
                  <thead style={{ backgroundColor: "#e9ecef" }}>
                    <tr>
                      <th className="small py-2 text-center" style={{ width: '5%' }}>Sr.</th>
                      <th className="small py-2" style={{ width: '25%' }}>Name</th>
                      <th className="small py-2" style={{ width: '10%' }}>Type</th>
                      <th className="small py-2 text-center" style={{ width: '15%' }}>Dosage</th>
                      <th className="small py-2 text-center" style={{ width: '20%' }}>B/L/D</th>
                      <th className="small py-2 text-center" style={{ width: '10%' }}>Days</th>
                      <th className="small py-2" style={{ width: '15%' }}>Instr</th>
                    </tr>
                  </thead>
                  <tbody>
                    {prescription.map((medicine, idx) => (
                      <tr key={medicine?.id || idx}>
                        <td className="small text-center">{idx + 1}</td>
                        <td className="small fw-bold">{medicine?.medicineName}</td>
                        <td className="small">{medicine?.type}</td>
                        <td className="small text-center">{medicine?.dosage || "-"}</td>
                        <td className="small text-center">
                          {medicine?.breakFastDose || "-"}/{medicine?.lunchDose || "-"}/{medicine?.dinnerDose || "-"}
                        </td>
                        <td className="small text-center">{medicine?.days}</td>
                        <td className="small">{medicine?.instruction || medicine?.notes || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div className="d-flex justify-content-end gap-2 p-2 bg-light border-top">
                  <Button variant="outline-danger" size="sm" onClick={() => deletePrescriptionHandler(prescription)}>
                    <FaTrash className="me-2" /> Delete
                  </Button>
                  <Button style={{ backgroundColor: 'var(--primary-color)', borderColor: 'var(--primary-color)' }} size="sm" onClick={() => selectPrescriptionHandler(prescription)}>
                    <FaCheck className="me-2" /> Select Prescription
                  </Button>
                </div>
              </div>
            </div>
          ))
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.OnCloseModalBlock} style={{ backgroundColor: 'var(--primary-color)', borderColor: 'var(--primary-color)' }}>
          <FaTimes className="me-2" /> {t("Close")}
        </Button>
      </Modal.Footer>
      <ConfirmModal
        show={showConfirmModal}
        onHide={() => setShowConfirmModal(false)}
        onConfirm={confirmDeleteHandler}
        title="Delete Prescription"
        message="Are you sure you want to delete this prescription?"
        variant="danger"
        isLoading={isDeleting}
      />
    </Modal>
  );
};

export default DataModal;
